import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const messageTemplateUrl = `${SERVER_API}/message-template`;

export const MESSAGE_TEMPLATE = {
  ...generateCrudEndpoints(messageTemplateUrl),
};
